import * as React from "react";

function SvgServerInstall({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M17 12.25a4.752 4.752 0 014.745 4.555l.005.213-.006.218a4.751 4.751 0 01-4.528 4.51L17 21.75H7a4.752 4.752 0 01-4.745-4.555l-.005-.213.006-.218a4.751 4.751 0 014.528-4.51L7 12.25h10zm0 1.5H7c-1.734 0-3.161 1.362-3.245 3.069L3.75 17A3.25 3.25 0 007 20.25h10c1.734 0 3.161-1.362 3.245-3.069L20.25 17A3.25 3.25 0 0017 13.75zM6.434 16.435a.8.8 0 01.973-.124l.09.062.068.062.084.1.056.087.047.104a.797.797 0 01-.11.75l-.077.09-.09.078a.798.798 0 01-1.041-.078.799.799 0 010-1.131zM17 16.25a.75.75 0 01.102 1.493L17 17.75h-6l-.102-.007a.75.75 0 010-1.486L11 16.25zm-4.47-5.72l-.07.061.007-.005-.018.015.01-.01-.048.036a.495.495 0 01-.063.037l-.026.014a.993.993 0 01-.09.036l-.008.002-.025.007a.724.724 0 01-.312.019l-.035-.007c-.025-.005-.05-.01-.074-.018l-.032-.011c-.025-.009-.05-.02-.073-.03l-.032-.017a.948.948 0 01-.075-.047l-.012-.01a.617.617 0 01-.084-.072l-3-3a.749.749 0 01.976-1.133l.084.073 1.72 1.719V3a.75.75 0 011.493-.102L12.75 3v5.189l1.72-1.72a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-3 3-.04.037-.013.011.053-.048z"
        />
      </g>
    </svg>
  );
}

export default SvgServerInstall;
